export const GET_USER_STATUS_DEFINITIONS = "GET_USER_STATUS_DEFINITIONS"
export const GET_USER_STATUS_DEFINITIONS_SUCCESS = "GET_USER_STATUS_DEFINITIONS_SUCCESS"
export const GET_USER_STATUS_DEFINITIONS_FAIL = "GET_USER_STATUS_DEFINITIONS_FAIL"



export const USER_STATUS_DEFINITION_API_ERROR = "USER_STATUS_DEFINITION_API_ERROR"
